import { render, staticRenderFns } from "./WalletChooserComponent.vue?vue&type=template&id=58ce390a&scoped=true&"
import script from "./WalletChooserComponent.vue?vue&type=script&lang=ts&"
export * from "./WalletChooserComponent.vue?vue&type=script&lang=ts&"
import style0 from "./WalletChooserComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WalletChooserComponent.vue?vue&type=style&index=1&id=58ce390a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ce390a",
  null
  
)

export default component.exports